import buildPath from '@/tsClient/utilities/buildPath';
import integrationsClient, { ApiDefinition } from '@/tsClient/servers/integrationsService';

type THIS_API = ApiDefinition['/{provider}/user-workflows/{userWorkflowId}/case-submission-attempt']['GET'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

const getLatestCaseSubmission = async ({ provider, userWorkflowId }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>('/{provider}/user-workflows/{userWorkflowId}/case-submission-attempt', { provider, userWorkflowId });
  const response = await integrationsClient.get(path);
  return response.data;
};

export default getLatestCaseSubmission;
